import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { showVOCSurvey } from '../../../actions/index';

type ManualEndSessionProps = {
    endBotSession: (value: boolean) => void;
    timeoutType: number;
    endScreenMountingStyle: string;
}

const ManualEndSession = ({endBotSession, timeoutType, endScreenMountingStyle}: ManualEndSessionProps)  => {

    // 1 user exits from the cross
    // 2 timeout text after 10 mins
    // 3 user ends after query
    // 4 close after live chat
    
    const endSession = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    let screenText;

    switch (timeoutType) {
        case 1: 
            screenText = `<div class="warning-msg">Have you finished your chat?</div>`;
            break;
        case 2:
            screenText = `<div class="warning-msg">Are you still there or have you finished your chat?</div>`;
            break;
        case 3:
            screenText = `<div>Too easy! Feel free to drop by next time you need a hand.</div>`;
            break;
        case 4:
            screenText = `<div class="cancel-text">Thank you for your feedback.</div>
                          <div>Have you finished your chat session?</div>`;
            break;
        default:
            screenText = `<div>No problem. I enjoyed our chat, stop by</div>
                          <div class="cancel-text">again sometime.</div>
                          <div>Have you finished your chat session?</div>`;
        break;
    }


    useEffect(() => {
        let timeoutId: ReturnType<typeof setTimeout> | null = null;
        
        window.onclick = (event:Event) => {
            const { className } = event.target as HTMLElement;
            if ( endSession.current && !endSession.current.contains(event.target as HTMLElement) && className && className.indexOf('header') && className.indexOf('brand') ) {
                timeoutId =  setTimeout(() => {
                    endBotSession(false)
                }, 450);
            }
        }
        
        return () => {
            if(timeoutId) { clearTimeout(timeoutId);}
        }
    }, [])
    
    
    

    return (

            <div className={"widget__overlay--endsession" + endScreenMountingStyle} ref={endSession}  id="endSession">  
            <div className="warning-text" dangerouslySetInnerHTML={{__html: screenText}}></div>

            <div className="action-buttons">
                <input type="button" value="RETURN TO CHAT" id="no-button" className='form-button secondary' onClick={ () => endBotSession(false) }/>
                <input type="button" value="FINISHED" id="yes-button" className='form-button secondary' onClick={ () => dispatch(showVOCSurvey(true)) }/>
            </div>
       </div>
    )
}

export default ManualEndSession